import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { Acoplamento } from '../../types/logistica';
import { acoplamentosService } from '../../services';

const columns: ResourceColumn<Acoplamento>[] = [
  { header: "Caminhão", accessor: "caminhao_display" },
  { header: "Reboque", accessor: "reboque_display" },
  { header: "Data Início", accessor: "data_inicio" },
  { header: "Data Fim", accessor: "data_fim" },
  { header: "Ativo", accessor: "ativo" },
];

export const AcoplamentosListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Acoplamentos"
      description="Gestão de acoplamentos de veículos."
      columns={columns}
      service={acoplamentosService}
      createPath="/admin/logistica/acoplamentos/novo"
      onEdit={(item) => item.id && navigate(`/admin/logistica/acoplamentos/${item.id}`)}
    />
  );
};
